import { FacilityTypes } from 'src/enums'

export enum NotificationTriggerType {
  DeviationCreated = 0,
  DeviationStatusChanged = 1,
  WorkOrderCreated = 2,
  WorkOrderStatusChanged = 3,
  ServiceDueSoon = 4,
  ServiceOverdue = 5,
  CertificateExpiringSoon = 6,
  CertificateExpired = 7,
  DeviationUpdated = 8,
  WorkOrderUpdated = 9,
  ReportFilled = 10,
  WorkAssignmentCreated = 11,
  WorkAssignmentUpdated = 12,
}

export interface INotification {
  id: number
  customerId: number
  title: string
  body: string
  link?: string
  triggerType: NotificationTriggerType
  isRead: boolean
  relatedEntityId?: number
  relatedEntityType?: string
  messageKey?: string
  data?: Record<string, string>
  createdAt: string
}

export interface ISubscriptionStatus {
  isFollowing: boolean
  subscriptionId?: number
}

export interface IEntitySubscription {
  id: number
  entityType: string
  entityId: number
  createdAt: string
}

export interface ICreateSubscription {
  entityType: string
  entityId: EntityId
}

export enum NotificationCategory {
  Deviations = 0,
  WorkOrders = 1,
  Service = 2,
  Certificates = 3,
  Reports = 4,
  WorkAssignments = 5,
}

export interface INotificationPreference {
  category: NotificationCategory
  inApp: boolean
  email: boolean
  includeUpdates: boolean
}

export interface INotificationScopeItem {
  type: FacilityTypes
  mappingId: number
}

export interface ISelectableFacility {
  type: FacilityTypes
  id: number
  name: string
}
